<div class="divWhiteBackground" id="capq-error-page">
  <div class="d-flex flex-column align-items-center">
    <h2 class="dark-blue text-center">
      We apologize for the inconvenience. We're unable to complete your request
      at this time. Please check back later.
    </h2>
    <div class="pt-61 pb-60">
      <div class="col-md-12 form-group center">
        <button
          class="btn btn-primary btn-default width-100"
          (click)="navigateHome()"
        >
          GO TO THE HOMEPAGE
        </button>
      </div>
    </div>
  </div>
</div>
